import Helpers from "@/Helpers"
import Tracking from "./Tracking";
import qs from "qs";

export default {
  route,
  isMtd() {
      return this.$page.props.auth.user.role === 'mtd';
  },
  isTu() {
      return this.$page.props.auth.user.role === 'shop';
  },
  isAdmin() {
      return this.$page.props.auth.user.role === 'admin' || this.$page.props.auth.user.role === 'sa';
  },
  userCanEditPrice(isWholesale) {
    let canEdit = ((!isWholesale && this.isMtd()) ||
    (isWholesale && (['admin', 'sm', 'rsm', 'acct', 'sa']).includes(this.$page.props.auth.user.role)));

    return canEdit;
  },
  isUserHasToolFair2023() {
    return (this.$page.props.auth?.user?.tags || []).some(t => t.name === 'Tool Fair 2023')
  },
  queryHas(key) {
    return this.query?.has(key)
  },
  inToolFair2023() {
    return this.isUserHasToolFair2023() && (this.queryHas('tool-fair-2023') || this.$page.props.sessions?.in_tool_fair_2023)
  },
  mergeQueryParams(params = {}) {
    if (this.query instanceof URLSearchParams) {
      return Object.assign(qs.parse(this.query.toString()), params)
    }
    return params
  },
  formatPhone(phoneNumber) {
      let cleaned = ('' + phoneNumber).replace(/\D/g, '');
      let match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);

      if (match) {
          let intlCode = (match[1] ? '+1 ' : '');
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      }

      return phoneNumber;
  },
  formatDollars(amount){
    let result = '';
    if (amount < 0)
    {
      result += '-';
    }
    result += '$' + this.formatCurrency(Math.abs(amount));
    return result;
  },
  formatCurrency: Helpers.formatCurrency,
  userInfo: function(props) {
    const { user } = props.auth

    if (user) {
      let roleLetter
      if (this.isMtd()) roleLetter = 'M'
      else if (this.isTu()) roleLetter = 'T'
      else roleLetter = 'A'
  
      return {
        'role': user.role,
        'full_name': user.first_name + ' ' + user.last_name + ' -' + roleLetter,
        'first_name': user.first_name,
        'last_name': user.last_name,
        'company_name': user.company_name
      }
    }
  },
  downloadResponse(response, defaultFilename = 'export.xlsx') {
    const header = response.headers['content-disposition'] || ''
    const filename = header.substr(header.indexOf('filename=') + 9) || defaultFilename
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  },
  trackAddToCart: Tracking.trackAddToCart,
  trackRemoveFromCart: Tracking.trackRemoveFromCart,
  trackCartQuantityUpdate: Tracking.trackCartQuantityUpdate,
  trackPurchase: Tracking.trackPurchase,
  setGaInfo: Tracking.setGaInfo
}
